export function reverseArray(array) {
  var newArray = [];

  for (let i = array.length - 1; i >= 0; i--) {
    newArray.push(array[i]);
  }

  return newArray;
}



// WEBPACK FOOTER //
// ./src/HOCs/Helpers/Utilities.js